<script>
export default
{
    name: 'image-tile',

    props:
    {
        title: { type: String, required: true },
        description: { type: String },
        date: { type: String },
        backgroundImage: {  },
        strongFilterShadow: { type: Boolean, default: false },
    },

    render () 
    {
        const backgroundFilter = `linear-gradient(to bottom, rgba(0, 0, 0, ${this.strongFilterShadow ? '0.4' : '0.2'}), rgba(0, 0, 0, 0.8)), url(${this.backgroundImage})`
        
        return (
            <div on-click={this.onTileClicked} class='image-tile'
                style={{ backgroundImage: backgroundFilter }}>
                <div class='tile-inside'>
                    <span class='title'>{ this.title }</span>
                    <div v-show={this.date} style={{ width: '100%', height: '2vh' }} />
                    <span class='date' v-show={this.date}>
                        <inline-svg src={require('@/assets/img/calendar-icon.svg')} /> { this.date }
                    </span>
                    <div v-show={this.description} style={{ width: '100%', height: '1vh' }} />                    
                    <div class='subtitle' domPropsInnerHTML={this.description} />
                    { this.$slots.default }
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onTileClicked (event)
        {
            this.$emit('click', event, this)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.image-tile
{
    cursor: pointer;
    border-radius: 25px;
    box-shadow: 0 0px 8px 3px rgba(0, 0, 0, 0.15);
    background-position: center;
    background-size: cover;
    padding: 7% 0 6% 0;

    .OnTablet({
        padding: 6% 0 3% 0;
    });
    .OnDesktop({
        padding: 3% 0 2.5% 0;
    });    
    .OnLarge({
        padding: 3% 0 1.5% 0;
    });

    .tile-inside
    {
        padding: 0 6%;
        width: -webkit-fill-available;
        text-shadow: 2px 2px 0 black;

        .title
        {
            color: white;
            font-family: Nunito;
            font-weight: bold;
            font-size: 5vw;
            display: block;

            .OnTablet({
                font-size: 3.5vw;
            });
            .OnDesktop({
                font-size: 1.2vw;
            });            
            .OnLarge({
                font-size: 1.1vw;
            });

            .CapitalizeFirstLetter();
        }

        .date
        {
            color: #EBEEF5;
            margin: 2% 0 40% 0;
            font-size: 3vw;

            .OnTablet({
                font-size: 2vw;
            });
            .OnDesktop({
                font-size: 0.8vw;
            });            
            .OnLarge({
                font-size: 0.7vw;
            });
        }

        .date > svg
        {
            fill: white;
            height: 3vw;
            width: auto;
            margin-right: 1vw;
            vertical-align: text-top;

            .OnTablet({
                height: 2vw;
            });

            .OnDesktop({
                height: 0.8vw;
                margin-right: 0.5vw;
            });
        }

        .subtitle
        {
            color: #EBEEF5;
            font-family: Nunito;
            font-size: 4vw;
            display: block;

            .OnTablet({
                font-size: 2.5vw;
            });
            .OnDesktop({
                font-size: 1vw;
            });            
            .OnLarge({
                font-size: 0.8vw;
            });

            .CapitalizeFirstLetter();
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ImageTile.vue